import type { Teacher } from "@/services/api.service";

type TeacherRelationshipDisplayInput = {
  teacherId: number | null | undefined;
  teacherName: string | null | undefined;
  teacherUsername: string | null | undefined;
  teacherEmail: string | null | undefined;
};

type TeacherRelationshipDisplay = {
  primary: string;
  secondary: string[];
};

export const formatTeacherRelationshipDisplay = ({
  teacherId,
  teacherName,
  teacherUsername,
  teacherEmail,
}: TeacherRelationshipDisplayInput): TeacherRelationshipDisplay => {
  const primary =
    teacherName?.trim() || teacherUsername?.trim() || (teacherId ? `Teacher ${teacherId}` : "No teacher assigned");

  const secondary: string[] = [];
  if (teacherUsername?.trim() && teacherUsername.trim() !== primary) {
    secondary.push(`Username: ${teacherUsername.trim()}`);
  }
  if (teacherEmail?.trim()) {
    secondary.push(`Email: ${teacherEmail.trim()}`);
  }
  if (teacherId != null) {
    secondary.push(`ID: ${teacherId}`);
  }

  return { primary, secondary };
};

export const formatTeacherSelectLabel = (teacher: Teacher): string => {
  const segments = [teacher.name.trim()];
  if (teacher.username?.trim()) {
    segments.push(`@${teacher.username.trim()}`);
  }
  if (teacher.email?.trim()) {
    segments.push(teacher.email.trim());
  }
  segments.push(`ID ${teacher.teacher_id}`);
  return segments.join(" • ");
};

export const formatClassroomAssignmentsLabel = (count: number): string =>
  `${count} student${count === 1 ? "" : "s"}`;
